import type { UnitInfoGrizzlyFeederInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import type { GrizzlyFeederUnitInfoDataMapInterface } from './unitInfoData';

/* Returns the amount of decks for the model. If the last number equals 2 it has one deck, else none */
export const getNbrOfDecks = (modelName: string): number => {
  if (modelName.charAt(modelName.length - 1) === '2') {
    return 1;
  }
  return 0;
};

export const getDefaultData = (
  unitInfoData: GrizzlyFeederUnitInfoDataMapInterface,
): UnitInfoGrizzlyFeederInterface => {
  if (!unitInfoData) {
    throw new Error('no unit info data available');
  }
  return {
    modelName: 'SV1032',
    moisture: 0,
    newMoisture: false,
    decks: {
      0: { separationSize: 100, display: { separationSize: true } },
      1: { separationSize: 30, display: { separationSize: true } },
    },
    inclination: 0,
    parallelUnits: 1,
    otherModel: false,
    otherModelMaxFeedSize: 0,
    otherModelNominalCapacity: 0,
    customModelTwoDecks: false,
    nbrOfOutputs: 2,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayInclination: false,
      displayLoad: true,
      displaySepSizeDeck1: true,
      displaySepSizeDeck2: true,
    },
  };
};

export class GrizzlyFeederSVConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoGrizzlyFeederInterface {
    const unitInfoData = params?.data as
      GrizzlyFeederUnitInfoDataMapInterface | undefined;

    if (!unitInfoData) {
      throw new Error('no unit info data available');
    }
    return {
      modelName: 'SV1032',
      ...BaseUnitConfig.getBaseDefaults(),
      decks: {
        0: { separationSize: 100, display: { separationSize: true } },
        1: { separationSize: 30, display: { separationSize: true } },
      },
      inclination: 0,
      otherModel: false,
      otherModelMaxFeedSize: 0,
      otherModelNominalCapacity: 0,
      customModelTwoDecks: false,
      nbrOfOutputs: 2,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayInclination: false,
        displayLoad: true,
        displaySepSizeDeck1: true,
        displaySepSizeDeck2: true,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 3;
  }
}

export const grizzlyFeederSVConfig = new GrizzlyFeederSVConfig();
